export const TATTOOIST_FORM = 'TATTOOIST_FORM';
export const TATTOO_OPERATOR_FORM = 'operator';
